<template>
  <div class="RechargeDetailed">
    <div class="personal-box comWidth">
      <CenterNav/>
      <div class="personal-right">
        <NavT :titleS="titleS"/>
        <div class="rightmain">
          <el-table
            border
            :data="tableData"
            style="width: 100%">
            <el-table-column
              prop="date"
              label="操作時間"
              width="180">
            </el-table-column>
            <el-table-column
              prop="type"
              label="類型"
              width="180">
            </el-table-column>
            <el-table-column
              prop="money"
              label="金額">
            </el-table-column>
            <el-table-column
              prop="state"
              label="狀態">
            </el-table-column>
          </el-table>
          <div class="all" style="text-align: right;">
            您當前的可用資金為：  <span>￥0.00</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  //nav
  import NavT from '@/pages/personalPage/NavT'
  //cNav
  import CenterNav from '@/pages/personalPage/CenterNav'
  export default {
    name: 'RechargeDetailed',
    components:{
      NavT,
      CenterNav
    },
    data () {
      return {
        titleS:'充值明細',
        tableData: [{
          date: '2016-05-02',
          type: '21',
          money: '35',
          state: '充值成功'
        }]

      }
    },
    created(){
      window.scrollTo(0,0)
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.all{
  text-align: right;
  span{
    margin: 0 20px;
    color: #0055a0;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/personalPage/assetCenterPage/RechargeDetailed.vue